import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/styles';

import {
    Text,
    Input,
    KeyboardDatePicker,
    RadioGroup,
    Radio,
    PhoneFormat,
    IDFormat,
    ContainedButton,
} from '../index';

const MindGymIcon = '/resources/images/mindgym/mindgym-icon.svg';

export const PersonalInfoForm = ({
    data,
    mindGymUser,
    errors,
    disabledHNCode,
    onChange,
    disabledIDCardNumber,
    radioRow,
    disabledEmail,
    disabledMobile,
    onDateChange,
    disabledBirthday,
    disabledForm,
    showAddByID,
    showAddByEmail,
    showAddByMobile,
    handleAddExistUserToPatient,
    onValidationError,
}) => {
    const theme = useTheme();
    const dateValue = data.birthday ? new Date(data.birthday).toISOString() : null;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
            <Text $bold $fontSize="18px">
                Personal Information
            </Text>

            {mindGymUser && (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: theme.palette.common.primaryBlue,
                        minHeight: '48px',
                        width: '170px',
                        borderRadius: '8px',
                        columnGap: '13px',
                    }}
                >
                    <img src={MindGymIcon} alt="MindGymIcon" style={{ width: '37px' }} />
                    <Text $color="white">FRIDAY APP</Text>
                </div>
            )}

            <Input
                id="HNCode"
                label="ID Code"
                placeholder="ID Code"
                name="HNCode"
                value={data.HNCode}
                $inputMaxWidth="270px"
                disabled={disabledForm || disabledHNCode}
                onChange={onChange}
                max={30}
                helperText={errors.find((value) => value.property === 'HNCode')?.message}
            />

            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Input
                    id="IDCardNumber"
                    label="ID Card Number"
                    placeholder="ID Card Number"
                    name="IDCardNumber"
                    value={data.IDCardNumber}
                    required
                    InputProps={{
                        inputComponent: IDFormat,
                    }}
                    $inputMaxWidth="270px"
                    disabled={disabledForm || disabledIDCardNumber}
                    onChange={onChange}
                    helperText={errors.find((value) => value.property === 'IDCardNumber')?.message}
                />
                {showAddByID && (
                    <ContainedButton
                        $fontSize="12px"
                        style={{ paddingLeft: '20px', height: '32px', width: 'max-content' }}
                        onClick={() => handleAddExistUserToPatient('id')}
                        disabled={disabledForm}
                    >
                        Add Client To Counseling Service
                    </ContainedButton>
                )}
            </div>

            <Input
                id="fullname"
                label="Fullname"
                placeholder="Fullname"
                name="fullname"
                value={data.fullname}
                required
                max={100}
                $inputMaxWidth="460px"
                onChange={onChange}
                disabled={disabledForm || disabledForm}
                helperText={errors.find((value) => value.property === 'fullname')?.message}
            />
            <RadioGroup
                label="Gender"
                name="gender"
                value={data.gender}
                onChange={onChange}
                required
                helperText={errors.find((value) => value.property === 'gender')?.message}
            >
                <div
                    style={{
                        display: radioRow ? 'flex' : 'grid',
                        columnGap: radioRow ? '15px' : 0,
                        rowGap: '10px',
                        gridTemplateColumns: '1fr 1fr',
                        paddingLeft: '20px',
                    }}
                >
                    <Radio disabled={disabledForm} value="male" label="Male" />
                    <Radio disabled={disabledForm} value="female" label="Female" />
                    <Radio disabled={disabledForm} value="other" label="LGBTIQN+" />
                    <Radio disabled={disabledForm} value="none" label="Prefer not to say" />
                </div>
            </RadioGroup>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Input
                    id="email"
                    label="Mail"
                    placeholder="Mail"
                    name="email"
                    type="email"
                    value={data.email}
                    onChange={onChange}
                    required
                    max={50}
                    helperText={errors.find((value) => value.property === 'email')?.message}
                    $inputMaxWidth="460px"
                    disabled={disabledEmail || disabledForm}
                />
                {showAddByEmail && (
                    <ContainedButton
                        $fontSize="12px"
                        style={{ paddingLeft: '20px', height: '32px', width: 'max-content' }}
                        onClick={() => handleAddExistUserToPatient('email')}
                        disabled={disabledForm}
                    >
                        Add Client To Counseling Service
                    </ContainedButton>
                )}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Input
                    id="mobileNumber"
                    label="Mobile number"
                    placeholder="Mobile number"
                    name="mobileNumber"
                    value={data.mobileNumber}
                    onChange={onChange}
                    required
                    InputProps={{
                        inputComponent: PhoneFormat,
                    }}
                    $inputMaxWidth="460px"
                    disabled={disabledMobile || disabledForm}
                    helperText={errors.find((value) => value.property === 'mobileNumber')?.message}
                />
                {showAddByMobile && (
                    <ContainedButton
                        $fontSize="12px"
                        style={{ paddingLeft: '20px', height: '32px', width: 'max-content' }}
                        onClick={() => handleAddExistUserToPatient('mobileNumber')}
                        disabled={disabledForm}
                    >
                        Add Client To Counseling Service
                    </ContainedButton>
                )}
            </div>
            <KeyboardDatePicker
                id="birthday"
                label="Birthday"
                value={dateValue}
                onChange={onDateChange}
                $inputMaxWidth="270px"
                disableFuture
                disabled={disabledBirthday || disabledForm}
                onValidationError={onValidationError}
                helperText={errors.find((value) => value.property === 'birthday')?.message}
            />
        </div>
    );
};

PersonalInfoForm.propTypes = {
    data: PropTypes.object.isRequired,
    errors: PropTypes.array,
    disabledHNCode: PropTypes.bool,
    onChange: PropTypes.func,
    disabledIDCardNumber: PropTypes.bool,
    radioRow: PropTypes.bool,
    disabledEmail: PropTypes.bool,
    disabledMobile: PropTypes.bool,
    onDateChange: PropTypes.func,
    disabledBirthday: PropTypes.bool,
    disabledForm: PropTypes.bool,
    showAddByID: PropTypes.bool,
    showAddByEmail: PropTypes.bool,
    showAddByMobile: PropTypes.bool,
    handleAddExistUserToPatient: PropTypes.func,
};
